<i
  class="pi pi-exclamation-triangle"
  [pTooltip]="error"
  tooltipPosition="bottom"
  role="button"
  tabindex="0"
  [attr.aria-label]="error"
  (click)="scrollToErrorContainer()"
  (keydown.enter)="activateByKeyboard($event)"
  (keydown.space)="activateByKeyboard($event)"
></i>
